import { Dropdown } from "@vibe/core";
import React from "react";

interface SettingsDropdownProps {
  label: string;
  placeholder?: string;
  options?: { label: string; value: string | number }[];
  onChange?: (value: any) => void;
  multi?: boolean;
  defaultValue?: { label: string; value: string | number }[];
}

const SettingsDropdown = ({ label, placeholder, options, onChange, multi, defaultValue }: SettingsDropdownProps) => {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">{label}</p>
      <div className="max-w-[50%]">
        <Dropdown placeholder={placeholder} options={options} multi={multi} onChange={onChange} value={defaultValue} />
      </div>
    </div>
  );
};

export default SettingsDropdown;
